var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconRepeatLoopRemoveCancel = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.575 3.5H4.88143L3.88143 2.5L8.575 2.5L7.8 1.725L8.5 1L10.5 3L8.5 5L7.8 4.275L8.575 3.5Z",
    fill: "#625E70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11L1.5 9L3.5 7L4.2 7.725L3.425 8.5H7.07501L3.5 4.92499V5.5L2.5 5.5V3.92499L0.6875 2.11249L1.4 1.39999L10.6 10.6L9.8875 11.3125L8.07501 9.5H3.425L4.2 10.275L3.5 11Z",
    fill: "#625E70"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 8.11857L8.5 7.11857V6.5H9.5V8.11857Z",
    fill: "#625E70"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconRepeatLoopRemoveCancel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-repeat-loop-remove-cancel.0923bcda85fd5809027ebc09822e5417.svg";